import React, { Fragment } from 'react';
import {
  CTAButton2Wrapper,
  CTARatingContainer,
  CTAButtonWrapper,
  CTAHeadlineWrapper,
  CTARatingNumbersItem,
  CTAHeadlineText,
  CTAButtonLink
} from './components';
import {
  OwnUpGridItem,
  OwnUpFillButtonPrimary,
  OwnUpGridContainer,
  OwnUpLargeBody
} from '@rategravity/own-up-component-library';

import { RatingIcon } from '../../../images/icons/rating';

const www = `https://${process.env.GATSBY_WWW}`;

const CTAButtons2 = () => (
  <Fragment>
    <CTAButton2Wrapper>
      <OwnUpGridContainer variant="slim">
        <OwnUpGridItem xs={2} />
        <OwnUpGridItem xs={8}>
          <CTAHeadlineWrapper>
            <CTAHeadlineText variant="h3">See What You Qualify For</CTAHeadlineText>
          </CTAHeadlineWrapper>
          <CTARatingContainer>
            <CTARatingNumbersItem>
              <RatingIcon />
              <OwnUpLargeBody style={{ paddingTop: '16px', fontSize: '16px' }} variant="body1">
                4.98 RATING BY ZILLOW
              </OwnUpLargeBody>
            </CTARatingNumbersItem>
          </CTARatingContainer>
          <CTAButtonWrapper>
            <CTAButtonLink id="get_preapproved_blog" href={`${www}/onboarding/get-started/`}>
              <OwnUpFillButtonPrimary>Get Preapproved</OwnUpFillButtonPrimary>
            </CTAButtonLink>
          </CTAButtonWrapper>
        </OwnUpGridItem>
        <OwnUpGridItem xs={2} />
      </OwnUpGridContainer>
    </CTAButton2Wrapper>
  </Fragment>
);

export default CTAButtons2;
